export default {"src":"/_next/static/media/magnifyingGlass_24.54352880.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};